/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/image/ui/utils
 */
import { BalloonPanelView } from 'ckeditor5/src/ui';
/**
 * A helper utility that positions the
 * {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon contextual balloon} instance
 * with respect to the image in the editor content, if one is selected.
 *
 * @param {module:core/editor/editor~Editor} editor The editor instance.
 */

export function repositionContextualBalloon(editor) {
  var balloon = editor.plugins.get('ContextualBalloon');

  if (editor.plugins.get('ImageUtils').getClosestSelectedImageWidget(editor.editing.view.document.selection)) {
    var position = getBalloonPositionData(editor);
    balloon.updatePosition(position);
  }
}
/**
 * Returns the positioning options that control the geometry of the
 * {@link module:ui/panel/balloon/contextualballoon~ContextualBalloon contextual balloon} with respect
 * to the selected element in the editor content.
 *
 * @param {module:core/editor/editor~Editor} editor The editor instance.
 * @returns {module:utils/dom/position~Options}
 */

export function getBalloonPositionData(editor) {
  var editingView = editor.editing.view;
  var defaultPositions = BalloonPanelView.defaultPositions;
  var imageUtils = editor.plugins.get('ImageUtils');
  return {
    target: editingView.domConverter.viewToDom(imageUtils.getClosestSelectedImageWidget(editingView.document.selection)),
    positions: [defaultPositions.northArrowSouth, defaultPositions.northArrowSouthWest, defaultPositions.northArrowSouthEast, defaultPositions.southArrowNorth, defaultPositions.southArrowNorthWest, defaultPositions.southArrowNorthEast]
  };
}